<div class="inner-content _modal-component-wrapper" [ngClass]="{'_full-width': fullWidth}">
	<div class="_left">
		<div class="_left-scroll">
			<ng-content select="[left]"></ng-content>
		</div>
	</div>

	<div class="_right">
		<div class="_right-scroll">
			<ng-content select="[right]"></ng-content>
		</div>

		<div class="_buttons">
			<ng-content select="[buttons]"></ng-content>
		</div>
	</div>
	<div (click)="goBack()" class="_close-button">
		<ion-icon src="./assets/icons/close-outline.svg"></ion-icon>
	</div>
</div>

